import { styled } from '@mui/system';
import React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

import { LocaleContext } from '../../../contexts/language';
import { IntlProvider,FormattedMessage } from 'react-intl';
import ar from './ar.json';
import en from './en.json';

const languages = {
  ar,
  en
};

const FadedFeature = styled('div')({
  '-webkit-mask-image': 'linear-gradient(to bottom, black 50%, transparent 100%)',
  maskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)',
  height: '400px',
  overflowY: 'hidden',
});


const NonFadedFeature = styled('div')({});


export const FeatureContainer = ({ children }) => {
  const [showMore, setShowMore] = React.useState(false);

  const ChildContainer = showMore ? NonFadedFeature : FadedFeature;
  const localeConfig = React.useContext(LocaleContext);
  return <>
    <ChildContainer>
      {children}
    </ChildContainer>
    <Stack spacing={3} sx={{ alignItems:'center' }}>

      <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>
        {showMore ? (<Button variant={'contained'} color="primary" onClick={() => setShowMore(false)}><FormattedMessage id={'featureContainer.hideButtonText'} defaultMessage={'Hide Full Spec'}/></Button>) : (
          <Button variant={'contained'} color="primary"  onClick={() => setShowMore(true)}>
            <FormattedMessage id={'featureContainer.showButtonText'} defaultMessage={'Show Full Spec'}/>
          </Button>)}
      </IntlProvider>
      
    </Stack>
  </>;
};
FeatureContainer.propTypes={ children:PropTypes.node };
export default FeatureContainer;